import { render, staticRenderFns } from "./SlideTabbar.vue?vue&type=template&id=309ee4f6&scoped=true&"
import script from "./SlideTabbar.vue?vue&type=script&lang=js&"
export * from "./SlideTabbar.vue?vue&type=script&lang=js&"
import style0 from "./SlideTabbar.vue?vue&type=style&index=0&id=309ee4f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309ee4f6",
  null
  
)

export default component.exports